import { render, staticRenderFns } from "./DeleteDepartmentDialog.vue?vue&type=template&id=4d28f84a&scoped=true&"
import script from "./DeleteDepartmentDialog.vue?vue&type=script&lang=ts&"
export * from "./DeleteDepartmentDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d28f84a",
  null
  
)

export default component.exports